import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly'
import { hashHistory } from 'react-router'

import getMiddlewares from './middlewares'
import reducer from './reducers'

const middlewares = getMiddlewares(hashHistory)
const enhancers = composeWithDevTools(applyMiddleware(...middlewares))

const initialState = {}
export default createStore(reducer, initialState, enhancers)



// WEBPACK FOOTER //
// ./state/store.js